import React from 'react';
import { StyledList, StyledListItem, StyledLink } from './BottomLinks.styles.mjs';

const BottomLinks = ({ options }) => {
    return (React.createElement(StyledList, null, options === null || options === void 0 ? void 0 : options.map((option, key) => (React.createElement(StyledListItem, { key: key },
        React.createElement(StyledLink, { href: option.href }, option.name))))));
};

export { BottomLinks as default };
//# sourceMappingURL=BottomLinks.mjs.map
